import { usePlayerStore } from '../../player/store/playerStore'
import { formatToCommaWithLang, toCommaOptions } from '../../../util/formatUtil'
import { useFeatureToggleV2 } from '../../featureToggle/hooks/useFeatureToggleV2'
import { FeatureToggleV2Type } from '../../featureToggle/enum/FeatureToggleType'
import { useMemo } from 'react'

export const useBalanceFeatureToggleV2 = (language = navigator.language, options: Intl.NumberFormatOptions = toCommaOptions.maximumTwoDecimalPlaces) => {
  const [balance, currency, sessionWinLose, sessionTotalStake, sessionTotalWin] = usePlayerStore(x => [x.balance, x.currency, x.sessionWinLose, x.sessionTotalStake, x.sessionTotalWin])
  const displayCurrency = useFeatureToggleV2(FeatureToggleV2Type.displayCurrency)

  const formatedBalance = useMemo(() => formatToCommaWithLang(balance, language, options), [balance, language, options])
  const formatedSessionWinLose = useMemo(() => formatToCommaWithLang(sessionWinLose, language, options), [sessionWinLose, language, options])
  const formatedSessionTotalStake = useMemo(() => formatToCommaWithLang(sessionTotalStake, language, options), [sessionTotalStake, language, options])
  const formatedSessionTotalWin = useMemo(() => formatToCommaWithLang(sessionTotalWin, language, options), [sessionTotalWin, language, options])
  const showedCurrency = useMemo(() => displayCurrency ? currency : '', [currency, displayCurrency])

  return {
    balance: formatedBalance,
    currency: showedCurrency,
    sessionWinLose: formatedSessionWinLose,
    sessionTotalStake: formatedSessionTotalStake,
    sessionTotalWin: formatedSessionTotalWin,
  }
}
